export default __webpack_public_path__ + "static/media/close.4fb7dad0.svg";